import React from 'react';
import { Select, Space } from 'antd';
import { GlobalOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import { useAppTheme } from '../theme/ThemeProvider';

const { Option } = Select;

const LanguageSwitcher: React.FC = () => {
  const { i18n } = useTranslation();
  const { theme } = useAppTheme();

  const handleLanguageChange = (value: string) => {
    i18n.changeLanguage(value);
    localStorage.setItem('language', value);
  };

  return (
    <Space size="small">
      <GlobalOutlined style={{ color: theme.textSecondary, fontSize: '14px' }} />
      <Select
        value={i18n.language}
        onChange={handleLanguageChange}
        style={{ 
          width: 90,
          fontSize: '12px'
        }}
        size="small"
        variant="borderless"
      >
        <Option value="zh-CN">中文</Option>
        <Option value="en-US">EN</Option>
      </Select>
    </Space>
  );
};

export default LanguageSwitcher; 